document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.article-template__content h2');
    console.log(headers);
    if (headers.length > 0) {
      document.querySelector('.main-article-list').style.display = 'block';
    }
    window.onload = function () {
      const content = document.getElementById('blogcontents');
      const titles = content.querySelectorAll('h2');
      const subtitles = content.querySelectorAll('h3');
  
      titles.forEach((title) => {
        title.removeAttribute('style');
      });
      subtitles.forEach((subtitle) => {
        subtitle.removeAttribute('style');
      });
  
      let toc = '';
      let level = 0;
  
      const headerNumbers = [0, 0, 0, 0, 0, 0]; // Array to keep track of numbering up to h6
  
      const regex = /<h(\d)>(.*?)<\/h\1>/gi;
  
      const newContent = content.innerHTML.replace(regex, function (str, openLevel, innerHTML) {
        openLevel = parseInt(openLevel);
  
        // Update numbering for current level
        headerNumbers[openLevel - 1]++;
        // Reset numbering for deeper levels
        for (let i = openLevel; i < headerNumbers.length; i++) {
          headerNumbers[i] = 0;
        }
  
        // Generate the numbering string
        let numbering = '';
        for (let i = 0; i < openLevel; i++) {
          if (headerNumbers[i] > 0) {
            numbering += headerNumbers[i] + '.';
          }
        }
  
        if (openLevel > level) {
          toc += new Array(openLevel - level + 1).join('<ul class="ml">');
        } else if (openLevel < level) {
          toc += new Array(level - openLevel + 1).join('</ul>');
        }
        level = openLevel;
  
        const anchor = innerHTML.replace(/<.*?>/g, '').replace(/\s+/g, '_');
        toc += `<li><a href="#${anchor}"><span>${numbering}</span> ${innerHTML.replace(/<.*?>/g, '')}</a></li>`;
  
        return `<h${openLevel}><a name="${anchor}">${innerHTML}</a></h${openLevel}>`;
      });
  
      if (level) {
        toc += new Array(level + 1).join('</ul>');
      }
  
      content.innerHTML = newContent;
  
      const tocContainer = document.getElementById('blogtoc_content');
      if (tocContainer) tocContainer.innerHTML = toc;
    };
   document.addEventListener("DOMContentLoaded", function() {
            const disclaimerBox = document.getElementById('disclaimer-box');
            const details = disclaimerBox.querySelector('details');

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        details.classList.add('toggle-opening');
                         details.setAttribute('open', '');
                    } else {
                        details.classList.remove('toggle-opening');
                        details.removeAttribute('open');
                    }
                });
            });

            observer.observe(disclaimerBox);
        });
  });
  